import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import makeToReact from '../utils/rehypeToReact'
import AElement from './AElement'
import CSS from './TOCSection.module.scss'

const TOCSection = () => {
  const data = useStaticQuery(QUERY)
  return (
    <div className={CSS.root}>{renderAst(data.markdownRemark.htmlAst)}</div>
  )
}

/** Converts Remark Markdown AST to a React element. */
const renderAst = makeToReact({
  components: { a: AElement }
})

/**
 * GraphQL query
 */

const QUERY = graphql`
  query {
    markdownRemark(fields: { slug: { eq: "/TOC.html" } }) {
      fields {
        slug
      }
      htmlAst
      headings {
        value
        depth
      }
    }
  }
`

export default TOCSection
